import { create } from 'zustand';

export type AviMessageRole = 'user' | 'assistant';

export interface AviMessage {
  id: string;
  role: AviMessageRole;
  content: string;
  createdAt: string;
}

interface AviStore {
  messages: AviMessage[];
  composer: string;
  setComposer: (value: string) => void;
  clearComposer: () => void;
  appendMessages: (messages: AviMessage[]) => void;
  reset: () => void;
}

export const useAviStore = create<AviStore>((set) => ({
  messages: [],
  composer: '',
  setComposer: (composer) => set({ composer }),
  clearComposer: () => set({ composer: '' }),
  appendMessages: (messages) => set((state) => ({ messages: [...state.messages, ...messages] })),
  reset: () => set({ messages: [], composer: '' })
}));

